import React from "react";
import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const CHAPTERS = [
  {
    n: "01",
    title: "Small drops. No restock.",
    body: "Every release is cut once and never run again. When a piece sells through, it's gone — no repeats, no diffusion line, no outlet. Own it or miss it.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_braid-collections/artifacts/f83lebx3_DSC05117_Original.webp",
  },
  {
    n: "02",
    title: "Built heavy, worn hard.",
    body: "Garment-dyed heavyweight cotton, reinforced seams, hardware that survives the daily. We over-build everything so it breaks in instead of breaking down.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_braid-collections/artifacts/gooff6o1_DSC04932_Original.webp",
  },
  {
    n: "03",
    title: "From the street, for the street.",
    body: "No focus groups, no trend reports. Funky Apparel is drawn from the community it's worn in — Alcoa, Tennessee — designed by the people who actually wear it, shipped across the USA from day one.",
    img: "https://customer-assets-lqy194kg.emergentagent.net/job_braid-collections/artifacts/1sl3wgcx_DSC05107_Original.webp",
  },
];

const Reveal = ({ children, delay = 0 }) => (
  <span className="block overflow-hidden">
    <motion.span
      className="block"
      initial={{ y: "105%" }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 1, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto" className="w-full mx-auto px-4 sm:px-8 md:px-12 py-24 md:py-40">
    <div className="max-w-4xl mb-24">
      <p className="label text-[#6A7180] mb-8">// The Ethos</p>
      <h2 className="font-serif-display text-4xl sm:text-6xl lg:text-7xl leading-[0.9]">
        <Reveal>We don't chase</Reveal>
        <Reveal delay={0.08}><span className="volt" style={{ WebkitTextStroke: "1px #0B0E14", color: "#2B6BFF" }}>seasons.</span> We drop,</Reveal>
        <Reveal delay={0.16}>and we disappear.</Reveal>
      </h2>
    </div>

    <div className="space-y-0">
      {CHAPTERS.map((c, i) => (
        <motion.article
          key={c.n}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, ease }}
          className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 py-16 border-t border-[#0B0E14] items-start"
        >
          <div className="md:col-span-2">
            <span className="font-bodoni text-6xl md:text-7xl">{c.n}</span>
          </div>
          <div className="md:col-span-4">
            <div className="overflow-hidden">
              <motion.img
                src={c.img} alt={c.title}
                className="w-full aspect-[4/5] object-cover"
                initial={{ scale: 1.2 }} whileInView={{ scale: 1 }} viewport={{ once: true }}
                transition={{ duration: 1.4, ease }}
              />
            </div>
          </div>
          <div className="md:col-span-6 md:pt-4">
            <h3 className="font-serif-display text-3xl md:text-4xl mb-5 leading-tight">{c.title}</h3>
            <p className="text-[#3A4150] leading-relaxed max-w-md text-lg">{c.body}</p>
          </div>
        </motion.article>
      ))}
    </div>
  </section>
);
